<div *ngIf="effectiveChartSeries?.length">
  <p *ngIf="chartLabel" class="chart-title"><strong>{{chartLabel}}</strong></p>
  <app-chart #chart
             [series]="effectiveChartSeries"
             [height]="chartHeight"
             [xAxis]="xAxis"
             [yAxis]="yAxis"
             [showLegend]="showLegend"
             [axisLabel]="axisLabel"
             [weightScale]="weightScale"
             x="date"
             y="value">

  </app-chart>
  <div class="row">
  </div>
</div>

